import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridLinkOperator,
  gridClasses,
  GridToolbarColumnsButton,
  GridToolbarExportContainer,
} from "@mui/x-data-grid";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import FormControl from "@mui/material/FormControl";
import GridItemLogin from "components/Grid/GridItemLogin.js";
import Card from "components/Card/Card.js";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CardHeader from "components/Card/CardHeadertab.js";
import CloseIcon from "@mui/icons-material/Close";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import TextField from "@mui/material/TextField";
import Themphuongtien from "components/Danhmuc/Phuongtien/Themphuongtien.js";
import Capnhatphuongtien from "components/Danhmuc/Phuongtien/Capnhatphuongtien.js";
import Capnhatphuhieu from "components/Danhmuc/Phuongtien/Capnhatphuhieu.js";
import Danhmucphuongtienexcel from "components/Xuatexcel/Danhmuc/Danhmucphuongtienexcel.js";
import Config from "conFig.js";
//import dayjs from "dayjs";
import styles from "assets/jss/material-dashboard-react/components/tableviewStyle.js";
const useStyles = makeStyles(styles);
const datagridSx = {
  [`& .${gridClasses.cell}`]: {
    py: 1,
  },
  [`& .center`]: {
    justifyContent: "center !important",
  },
  borderRadius: 2,
  "& .MuiDataGrid-main": { borderRadius: 2 },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      "&:nth-of-type(2n)": { backgroundColor: "rgba(235, 235, 235, .7)" },
    },
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "rgba(0,0,255,0.6)",
    color: "rgb(255 255 255)",
    fontSize: 16,
  },
  "& .MuiInputBase-root": {
    height: "25px",
  },
};
const ptcolumn = [
  { field: "stt", headerName: "stt", width: 80, headerAlign: "center" },
  {
    field: "sodangky",
    headerName: "Số đăng ký",
    width: 250,
    headerAlign: "center",
  },
  {
    field: "taitrong",
    headerName: "Tải trọng",
    width: 160,
    headerAlign: "center",
  },
  {
    field: "succhua",
    headerName: "Sức chứa",
    width: 160,
    headerAlign: "center",
  },
  {
    field: "dmloaihinhvantai",
    headerName: "Loại hình vận tải",
    width: 400,
    headerAlign: "center",
  },
];
export default function Danhmucphuongtien() {
  const classes = useStyles();
  const [pageSize, setPageSize] = React.useState(50);
  const [xaphuong, setXaphuong] = React.useState([]);
  const [xaphuong_id, setXaphuong_id] = React.useState(0);
  const [loaihinh, setLoaihinh] = React.useState([]);
  const [donvi, setDonvi] = React.useState([]);
  const [donvi_id, setDonvi_id] = React.useState(0);
  const [phuongtien, setPhuongtien] = React.useState([]);
  const [phuongtien_id, setPhuongtien_id] = React.useState(0);
  const [bienkiemsoat, setBienkiemsoat] = React.useState("");
  const [openthem, setOpenthem] = React.useState(false);
  const [opencapnhat, setOpencapnhat] = React.useState(false);
  const [openphuhieu, setOpenphuhieu] = React.useState(false);
  const [disableBT, setDisableBT] = React.useState(true);
  const [disableBT1, setDisableBT1] = React.useState(true);
  const [alert, setAlert] = React.useState(false);
  const [
    trickUpdateDefaultValueLHVT,
    setTrickUpdateDefaultValueLHVT,
  ] = React.useState(1);
  const [
    trickUpdateDefaultValueDV,
    setTrickUpdateDefaultValueDV,
  ] = React.useState(1);
  const handleClose = () => {
    setOpenthem(false);
    getphuongtiendonvi();
  };
  const handleClosecapnhat = () => {
    setOpencapnhat(false);
    getphuongtiendonvi();
  };
  const handleClosephuhieu = () => {
    setOpenphuhieu(false);
    getphuongtiendonvi();
  };
  const openthempt = () => {
    setOpenthem(true);
    setDisableBT(true);
    setDisableBT1(true);
  };
  const opencnphuhieu = () => {
    if (bienkiemsoat.length > 0) {
      setOpenphuhieu(true);
      setDisableBT(true);
      setDisableBT1(true);
    }
  };
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getxaphuong = () => {
    var url = Config.backend + "/api/Donvi/getpxgialai?username=" + username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setXaphuong(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getloaihinhvantai = () => {
    var url =
      Config.backend +
      "/api/Phuongtien/getdmlhvantaitatca?username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setLoaihinh(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getdonvitheoloai = (loaihinhvalue) => {
    setDisableBT(true); // fix delete button
    var url =
      Config.backend +
      "/api/Donvi/getdvvtloaihinhtheophuongxa?loaihinh_id=" +
      loaihinhvalue +
      "&phuongxa_id=" +
      xaphuong_id +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setDonvi(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getphuongtiendonvi = () => {
    setDisableBT(true); // fix delete button
    setDisableBT1(true);
    if (donvi_id > 0) {
      var url =
        Config.backend +
        "/api/Donvi/getphuongtientheodonvi?donvi_id=" +
        donvi_id +
        "&username=" +
        username;
      fetch(url, obj)
        .then((res) => res.json())
        .then((data) => {
          setPhuongtien(data);
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    }
  };
  const quickSearchToolbar = () => {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput: string) =>
            searchInput
              .split(",")
              .map((value) => value.trim())
              .filter((value) => value !== "")
          }
          placeholder="Tìm kiếm"
        />
        <GridToolbarColumnsButton />
        <GridToolbarExportContainer>
          <Danhmucphuongtienexcel />
        </GridToolbarExportContainer>
      </Box>
    );
  };
  const xoaphuongtien = () => {
    var url = Config.backend + "/api/Phuongtien/xoaphuongtien";
    fetch(url, {
      method: "DELETE",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        id: phuongtien_id,
        username: username,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data === 1) {
          showNotification();
          getphuongtiendonvi();
          setDisableBT(true);
          setDisableBT1(true);
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  React.useEffect(() => {
    getxaphuong();
  }, []);
  return (
    <GridContainer>
      <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
        <FormControl style={{ width: "18%" }}>
          <Autocomplete
            freeSolo
            disableClearable
            size="small"
            options={xaphuong}
            getOptionLabel={(option) => option.ten}
            onChange={(event, value) => {
              setXaphuong_id(value.id);
              getloaihinhvantai();
              setDonvi([]);
              setTrickUpdateDefaultValueLHVT(
                trickUpdateDefaultValueLHVT == 1 ? 2 : 1
              );
              setDisableBT(true); // fix delete button
              setDisableBT1(true);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Chọn Xã/phường"
                InputProps={{
                  ...params.InputProps,
                  type: "search",
                  style: {
                    height: "32px",
                    paddingTop: "initial",
                  },
                }}
              />
            )}
          />
        </FormControl>
        <FormControl style={{ width: "18%", marginLeft: 10 }}>
          <Autocomplete
            key={trickUpdateDefaultValueLHVT}
            freeSolo
            disableClearable
            size="small"
            options={loaihinh}
            getOptionLabel={(option) => option.ten}
            onChange={(event, value) => {
              getdonvitheoloai(value.id);
              setTrickUpdateDefaultValueDV(
                trickUpdateDefaultValueDV == 1 ? 2 : 1
              );
              setDisableBT(true); // fix delete button
              setDisableBT1(true);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Chọn loại hình vận tải"
                InputProps={{
                  ...params.InputProps,
                  type: "search",
                  style: {
                    height: "32px",
                    paddingTop: "initial",
                  },
                }}
              />
            )}
          />
        </FormControl>
        <FormControl style={{ width: "18%", marginLeft: 10 }}>
          <Autocomplete
            key={[trickUpdateDefaultValueLHVT, trickUpdateDefaultValueDV]}
            freeSolo
            disableClearable
            size="small"
            options={donvi}
            getOptionLabel={(option) => option.tendonvi}
            onChange={(event, value) => {
              setDonvi_id(value.id);
              setDisableBT(true); // fix delete button
              setDisableBT1(true);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Chọn đơn vị"
                InputProps={{
                  ...params.InputProps,
                  type: "search",
                  style: {
                    height: "32px",
                    paddingTop: "initial",
                  },
                }}
              />
            )}
          />
        </FormControl>
        <FormControl style={{ width: "8%", marginLeft: 10 }}>
          <Button
            color="primary"
            variant="contained"
            style={{ height: 32 }}
            onClick={getphuongtiendonvi}
          >
            Xem
          </Button>
        </FormControl>
        <FormControl style={{ width: "11%", marginLeft: 10 }}>
          <Button
            color="success"
            variant="contained"
            style={{ height: 32 }}
            onClick={openthempt}
          >
            Thêm mới
          </Button>
        </FormControl>
        <FormControl style={{ width: "8%", marginLeft: 10 }}>
          <Button
            color="error"
            variant="contained"
            style={{ height: 32 }}
            disabled={disableBT}
            onClick={xoaphuongtien}
          >
            Xóa
          </Button>
        </FormControl>
        <FormControl style={{ width: "10%", marginLeft: 10 }}>
          <Button
            color="info"
            variant="contained"
            style={{ height: 32 }}
            disabled={disableBT1}
            onClick={opencnphuhieu}
          >
            Phù hiệu
          </Button>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={10} md={12} style={{ marginTop: 10 }}>
        <div style={{ height: 500, width: "100%" }}>
          <DataGrid
            getRowId={(row) => row.stt}
            rows={phuongtien}
            columns={ptcolumn}
            checkboxSelection={false}
            getRowHeight={() => "auto"}
            headerHeight={35}
            onRowClick={(params) => {
              setPhuongtien_id(params.row.id);
              setBienkiemsoat(params.row.sodangky);
              setDisableBT(false);
              setDisableBT1(false);
            }}
            onCellDoubleClick={(params, event) => {
              if (!event.ctrlKey) {
                setOpencapnhat(true);
                setDisableBT(true); // fix delete button
                setDisableBT1(true);
              }
            }}
            sx={datagridSx}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[20, 50, 100]}
            pagination
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterLogicOperator: GridLinkOperator.Or,
                },
              },
            }}
            components={{ Toolbar: quickSearchToolbar }}
          />
        </div>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <Modal
          open={openthem}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <GridContainer>
              <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={4}>
                <Card>
                  <CardHeader color="primary" style={{ height: 10 }}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={10}>
                        <FormControl
                          style={{ width: "100%", marginTop: "10px" }}
                        >
                          <h6
                            className={classes.cardTitleWhite}
                            style={{ marginTop: "-5px" }}
                          >
                            Thêm phương tiện
                          </h6>
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={1}></GridItem>
                      <GridItem xs={12} sm={12} md={1}>
                        <FormControl
                          style={{ width: "100%", marginTop: "1px" }}
                        >
                          <CloseIcon onClick={handleClose} />
                        </FormControl>
                      </GridItem>
                    </GridContainer>
                  </CardHeader>
                  <Themphuongtien />
                </Card>
              </GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
            </GridContainer>
          </div>
        </Modal>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <Modal
          open={opencapnhat}
          onClose={handleClosecapnhat}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <GridContainer>
              <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={4}>
                <Card>
                  <CardHeader color="primary" style={{ height: 10 }}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={10}>
                        <FormControl
                          style={{ width: "100%", marginTop: "10px" }}
                        >
                          <h6
                            className={classes.cardTitleWhite}
                            style={{ marginTop: "-5px" }}
                          >
                            Cập nhật phương tiện
                          </h6>
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={1}></GridItem>
                      <GridItem xs={12} sm={12} md={1}>
                        <FormControl
                          style={{ width: "100%", marginTop: "1px" }}
                        >
                          <CloseIcon onClick={handleClosecapnhat} />
                        </FormControl>
                      </GridItem>
                    </GridContainer>
                  </CardHeader>
                  <Capnhatphuongtien phuongtien_id={phuongtien_id} />
                </Card>
              </GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
            </GridContainer>
          </div>
        </Modal>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <Modal
          open={openphuhieu}
          onClose={handleClosephuhieu}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <GridContainer>
              <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={6}>
                <Card>
                  <CardHeader color="primary" style={{ height: 10 }}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={10}>
                        <FormControl
                          style={{ width: "100%", marginTop: "10px" }}
                        >
                          <h6
                            className={classes.cardTitleWhite}
                            style={{ marginTop: "-5px" }}
                          >
                            Cập nhật phù hiệu
                          </h6>
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={1}></GridItem>
                      <GridItem xs={12} sm={12} md={1}>
                        <FormControl
                          style={{ width: "100%", marginTop: "1px" }}
                        >
                          <CloseIcon onClick={handleClosephuhieu} />
                        </FormControl>
                      </GridItem>
                    </GridContainer>
                  </CardHeader>
                  <Capnhatphuhieu bienkiemsoat={bienkiemsoat} />
                </Card>
              </GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
            </GridContainer>
          </div>
        </Modal>
      </GridItem>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Xóa thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </GridContainer>
  );
}
